import { render } from "./property-feature.vue?vue&type=template&id=21871f3c"
import script from "./property-feature.js?vue&type=script&lang=js"
export * from "./property-feature.js?vue&type=script&lang=js"

import "./property-feature.vue?vue&type=style&index=0&id=21871f3c&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__